<!-- HM note -->
<template>
  <div :class="classWell">
    <p>
      <i v-if="showIcon" :class="classIcon"></i>
      <slot>{{note}}</slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'HMNote',
  props: {
    note: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'note'
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classWell() {
      return [
        'note-well',
        'text-info',
        'pt-2',
        'print-view-hide'
      ]
    },
    classIcon() {
      return [
        'note-icon',
        `icon-${this.icon}`
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
.note-well {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 5px 10px 5px 10px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}
.note-well p {
  padding: 10px 10px 0px 10px;
}
.note-icon {
  font-weight: bold;
  margin-right: 10px;
}
</style>